import React from 'react';
import { Box, Heading, Text, Button } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PageNotFound = () => {
    const isLoggedIn = useSelector(state => state.session.isAuthenticated);
    return (
        <Box textAlign="center" py={10} px={6} backgroundColor={'white'} height={'calc(100vh - 4rem)'}>
            <Heading
                display="inline-block"
                as="h2"
                fontSize={'13rem'}
            >
                404
            </Heading>
            <Text fontSize="3rem" mt={3} mb={2}>
                Page Not Found
            </Text>
            <Text color={'gray.500'} mb={6}>
                The page you're looking for does not seem to exist
            </Text>

            <Button
                as={RouterLink}
                to={isLoggedIn ? "/film" : "/admin-login"}
                color="blue"
                variant="solid">
                Go to Home
            </Button>
        </Box>
    );
};

export default PageNotFound;